'use client';

import { useEffect } from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import ModuleList, {
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';

export interface DestinationProps extends ModuleListProps {
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Destination = ({
  modules,
  personalizationData,
  trackingData,
}: DestinationProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'destination' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ModuleList modules={modules} />
    </div>
  );
};

Destination.displayName = 'Destination';

export default Destination;
